import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-teaser-main-dialog',
  templateUrl: './teaser-main-dialog.component.html',
})
export class TeaserMainDialogComponent {
  constructor(public matDialogRef: MatDialogRef<TeaserMainDialogComponent>) {}

  public close(): void {
    this.matDialogRef.close();
  }
}
